import moment from 'moment';
import DTO from './DTO';

class MetricDTO extends DTO {
  constructor(params, isValidInit) {
    const attributes = [
      {
        name: 'id',
        type: String,
        validators: [],
        labelKey: 'metric.id',
      },
      {
        name: 'metric_key',
        type: String,
        validators: [],
        labelKey: 'metric.metric_key',
      },
      {
        name: 'host_id',
        type: String,
        validators: [],
        labelKey: 'metric.host_id',
      },
      {
        name: 'value',
        type: String,
        validators: [],
        labelKey: 'metric.value',
      },
      {
        name: 'updated_at',
        type: moment,
        validators: [],
        labelKey: 'metric.updated_at',
      },
    ];
    super(attributes, params, isValidInit);
  }
}

export default MetricDTO;
